import React, { useState } from 'react'
import { Form} from 'antd';
import{ useFormLayout} from '@utils'

import { RegistrationFormButton } from './Form/RegistrationFormButton';
import { RegistrationFormInfo } from './Form/RegistrationFormInfo';
import { DefaultDevice, Mobile } from '../../utils/mediaQuery';
import { RegistrationFormProfile } from './Form/RegistrationFormProfile';
import { RegistrationFormSl } from './Form/RegistrationFormSl';

export function RegistrationForm({record, 
    onUpdate, 
    myRegistraton, 
    somethingChanged,
    setSomethingChanged,
    currentRegistrationType,
    setCurrentRegistrationType,
    isSl,
    getRentCost,
    originalLarper,
    refreshLarper,
    isUpdating
}) {

    const [profileSomethingChanged, setProfileSomethingChanged] = useState(false)

    const [form] = Form.useForm()
    form.setFieldsValue(record)

    const layout = useFormLayout();
    
    return (
        <Form 
        form={form}
        {...layout}
        name="basic"
        layout="horizontal"
        onFinish={onUpdate}
        >

        <Mobile>

            <RegistrationFormInfo 
                currentRegistrationType={currentRegistrationType}
                setCurrentRegistrationType={setCurrentRegistrationType}
                setSomethingChanged={setSomethingChanged}
                isSl={isSl}
                getRentCost={getRentCost}
                record={record}
                form={form}
            />

            <RegistrationFormProfile 
                originalLarper={originalLarper}
                refreshLarper={refreshLarper}
                setProfileSomethingChanged={setProfileSomethingChanged}
                profileSomethingChanged={profileSomethingChanged}
            />

            <RegistrationFormSl isSl={isSl} form={form} record={record}/>

            <RegistrationFormButton 
                profileSomethingChanged={profileSomethingChanged}
                myRegistraton={myRegistraton}
                somethingChanged={somethingChanged}
                isUpdating={isUpdating}
            />
        </Mobile>

        <DefaultDevice>
            <RegistrationFormButton 
                profileSomethingChanged={profileSomethingChanged}
                myRegistraton={myRegistraton}
                somethingChanged={somethingChanged}
                isUpdating={isUpdating}
            />

            <div id="registration-form-body" style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
            }}>
                <div id="registration-form-info" style={{width:'50%'}}>
                    <RegistrationFormInfo 
                        currentRegistrationType={currentRegistrationType}
                        setCurrentRegistrationType={setCurrentRegistrationType}
                        setSomethingChanged={setSomethingChanged}
                        isSl={isSl}
                        getRentCost={getRentCost}
                        record={record}
                        form={form}
                    />
                </div>

                <div id="registration-form-profile" style={{width:'45%'}}>
                    <RegistrationFormProfile 
                            originalLarper={originalLarper}
                            refreshLarper={refreshLarper}
                            setProfileSomethingChanged={setProfileSomethingChanged}
                            profileSomethingChanged={profileSomethingChanged}
                    />
                </div>
            </div>

            <RegistrationFormSl isSl={isSl} form={form} record={record}/>

        </DefaultDevice>
    </Form>
    )
}